import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    screenWidth: document.documentElement.clientWidth, //屏幕宽度
    screenHeight: document.documentElement.clientHeight, //屏幕高度
  },
  mutations: {
    windowScreen: (state, payload) => {
      state.screenWidth = payload.screenWidth;
      state.screenHeight = payload.screenHeight;
    }
  },
  actions: {

  }
})
